<template>
  <wt-detail-dialog title="" custom-class="app-dialog" append-to-element="app-layout-admin"
             :destroy-on-close="true" :modal="false" :visible.sync="visible">
    <component v-if="visible" :is="componentName" :component-type="componentType" :detailData="detailData" @on-dialog-action="onDialogAction" :form-code="formCode"></component>
  </wt-detail-dialog>
</template>

<script>
import WtDetailDialog from '../WtDetailDialog'
export default {
  name: 'wt-detail-page',
  props: ['visible', 'component-name', 'component-type', 'form-code', 'detail-data'],
  components: {
    WtDetailDialog
  },
  methods: {
    onDialogAction(data) {
      if (data === 'close') {
        this.$emit('update:visible', false)
      } else if (data === 'refresh') {
        if (this.$parent && this.$parent.requestList) {
          this.$parent.requestList()
          this.$emit('on-button-action', 'update')
          this.$emit('update:visible', false)
        } else if (this.$parent && this.$parent.$parent && this.$parent.$parent.requestList) {
          this.$parent.$parent.requestList()
          this.$emit('on-button-action', 'update')
          this.$emit('update:visible', false)
        } else {
          this.$emit('on-dialog-action', data)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
